import { ax } from './_ax';

const getIntake = async (appointmentId) => {
  const res = await ax.get(`/patient_intakes/${appointmentId}`);
  return res;
};

const updateIntake = async (appointmentId, responses) => {
  const res = await ax.patch(`/patient_intakes/${appointmentId}`, {
    responses,
  });
  return res;
};

const submitIntake = async (appointmentId, payload) => {
  const res = await ax.post(
    `/patient_intakes/${appointmentId}/submit`,
    payload,
  );
  return res;
};

// Reuse the existing patient_documents presign Lambda (same one mmj_cards uses).
// Returns a signed URL the caller can fetch as a blob and download.
//
// IMPORTANT: only ever return signed_url. The Lambda also echoes back the raw
// S3 `original` key when it can't produce a signed URL — treating that as a URL
// causes the browser to fetch it as a relative path and we end up downloading
// the SPA's index.html as the "PDF".
const getPdfViewUrl = async (pdfS3Key) => {
  if (!pdfS3Key) return null;
  const encoded = encodeURIComponent(JSON.stringify([pdfS3Key]));
  const res = await ax.get(`/patient_documents/presign?urls=${encoded}`);
  const first = res?.data && res.data[0];
  if (!first) return null;
  const signedUrl = first.signed_url;
  if (
    typeof signedUrl !== 'string' ||
    (!signedUrl.startsWith('https://') && !signedUrl.startsWith('http://'))
  ) {
    return null;
  }
  return signedUrl;
};

const patientIntakeService = {
  getIntake,
  updateIntake,
  submitIntake,
  getPdfViewUrl,
};

export default patientIntakeService;
